import React, { Component } from "react";
import PropTypes from "prop-types";

class ErrorBoundary extends Component {
  state = { hasError: false };

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });

    //logErrorToMyService(error, info);
    // eslint-disable-next-line no-console
    console.warn("Something went wrong. ", error, info);
  }

  renderError = () => {
    const { title, message } = this.props;
    return (
      <div>
        <h1>{title}</h1>
        <p>{message}</p>
      </div>
    );
  };

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    return hasError ? this.renderError() : children;
  }
}

ErrorBoundary.defaultProps = {
  title: "An error accourd.",
  message: "Something went wrong..."
};

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  message: PropTypes.string
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/common/ErrorBoundary/ErrorBoundary.js